
import Header from "../Components/Header"

import Footer from "../Components/Footer";
import CommonLanding from "../Components/CommonLanding";
import "swiper/css";
import "swiper/css/navigation";

export default function birthdayLanding() {

  return (

    <>
      <CommonLanding
      title="Celebrate Your Biggest Milestones on the Arabian Sea"
      subtitle="A private yacht. Your people. A celebration you'll never forget."
      heading="A Venue as Special as Your Occasion"
      text="Stop booking generic banquet halls. Bring your birthday or anniversary to the water with luxury decor, personalized cake, and sunset views."
      image="https://images.unsplash.com/photo-1556125574-d7f27ec36a06"
      ctaText="Check Availability"
      schema={{
        "@context": "https://schema.org/",
        "@type": "Service",
        "serviceType": "Yacht Birthday & Anniversary Celebrations",
        "provider": {
          "@type": "LocalBusiness",
          "name": "IndiaBoats"
        }
      }}
      features={[
        { title: "Custom Decor", desc: "Balloons, floral setups, red carpets." },
        { title: "Entertainment", desc: "DJ or live musicians onboard." },
        { title: "Dining", desc: "Multi-cuisine gourmet menus." }
      ]}
    />
      {/* Header */}
   <Header/>
<>

<section className="ib-bday-wrapper">
  {/* HERO */}
  <div className="ib-bday-hero">
    <div className="ib-bday-container">
      <h1 className="ib-bday-title">
        Celebrate Your Biggest Milestones on the Arabian Sea
      </h1>
      <p className="ib-bday-subtitle">
        A private yacht. Your people. A celebration you'll never forget.
      </p>
    </div>
  </div>
  {/* INTRO */}
  <div className="ib-bday-section">
    <div className="ib-bday-container ib-bday-grid">
      <div className="ib-bday-content">
        <h2 className="ib-bday-heading">A Venue as Special as Your Occasion</h2>
        <p className="ib-bday-text">
          Stop booking generic banquet halls. Bring your birthday or anniversary
          to the water. Whether it’s a surprise 30th birthday or a silver
          anniversary, we provide a decorated deck, a personalized cake, and a
          sunset backdrop that no hotel can match.
        </p>
      </div>
      <div className="ib-bday-image">
        <img
          src="https://images.unsplash.com/photo-1556125574-d7f27ec36a06?auto=format&fit=crop&w=1000&q=80"
          alt="Yacht celebration"
        />
      </div>
    </div>
  </div>
  {/* FEATURES */}
  <div className="ib-bday-features">
    <div className="ib-bday-container">
      <h2 className="ib-bday-heading-center">What You Get Onboard</h2>
      <div className="ib-bday-feature-grid">
        <div className="ib-bday-card">
          <h3>Custom Decor</h3>
          <p>
            Balloons, floral arrangements, and red carpets designed to match
            your celebration.
          </p>
        </div>
        <div className="ib-bday-card">
          <h3>Entertainment</h3>
          <p>On-board DJ or live acoustic musicians to set the perfect mood.</p>
        </div>
        <div className="ib-bday-card">
          <h3>Gourmet Dining</h3>
          <p>Multi-cuisine menus curated specially for your guests.</p>
        </div>
      </div>
    </div>
  </div>
  {/* CTA */}
  <div className="ib-bday-cta">
    <div className="ib-bday-container ib-bday-cta-inner">
     
      <a href="/contact" className="ib-bday-btn">
        Book Your Yacht
      </a>
    </div>
  </div>
</section>


</>

             <Footer/>
        

          </>
         
);
}